import { render, staticRenderFns } from "./Under16.vue?vue&type=template&id=230f14cc"
import script from "./Under16.vue?vue&type=script&lang=js"
export * from "./Under16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports